module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCAzOCAzMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+dHNoaXJ0LWljb248L3RpdGxlPjxwYXRoIGQ9Ik0yNC4wODQgMi4wMTVBNS40NDYgNS40NDYgMCAwIDEgMTMuOTUyIDJMMiA3LjE3bDMuMzQzIDcuNzMgMy44ODMtMS42OHYxNi4zODVoMTkuNzI5VjEzLjI5OWwzLjcgMS42MDFMMzYgNy4xNyAyNC4wODQgMi4wMTV6IiBzdHJva2U9IiMyQzNFNTAiIHN0cm9rZS13aWR0aD0iMS44IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/tshirt-icon.svg
// module id = 677
// module chunks = 0